import { selectFeatureFlag } from '../../selectors/feature-flags';

export const getShouldDisableMqttSubs = state => selectFeatureFlag(state, 'disable-mqtt-subscriptions');
